import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import BannerLanding from '../components/BannerLanding'
//import { Grid, Row, Col } from 'react-flexbox-grid';

const pageTitle = "Suivi securite";
const pageContent = ["Un doute sur la sécurité de votre site Internet ou applications ? ", "Besoin de mises à jours spécifiques  ? "];

const Generic = (props) => (
	<div style={props.transition && props.transition.style}>
		<Helmet>
			<title>Web 2 Alpes - Suivi sécurité de sites internet, applications, poste de travail, serveurs, par-feu et réseaux informatique</title>
			<meta name="description" content="Suivi sécurité de sites internet, applications, poste de travail, serveurs, par-feu et réseaux informatique" />
			<meta name="language" content="fr-FR" />
            <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
            <meta http-equiv="content-language" content="fr-FR" />
		</Helmet>
		<BannerLanding title={pageTitle} content={pageContent} particles="infra" />
		<div id="main" className="alt">
			<section id="support" className="tiles">
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Une necessite !</h2>
						</header>
						<p>Aujourd'hui, la sécurité est devenue un enjeu majeur dans le monde de l'informatique. Face aux incidents majeurs répétés et relayés par la presse ces dernières années, elle est devenue incontournable. La législation évolue d'ailleurs dans ce sens avec <strong>une nouvelle législation (<a href="https://www.cnil.fr/fr/principes-cles/rgpd-se-preparer-en-6-etapes" target="_blank">RGPD</a>)</strong>.</p>
						<p>Il est important de savoir que des <strong>défauts de sécurité</strong> peuvent : </p> 
						<ul className="snow">
                            <li><strong>nuire à l'image de votre entreprise</strong> (défiguration de sites web, déni de service...)</li>
							<li><strong>entraîner des amendes conséquentes</strong> si vous traitez des données <strong>d'utilisateurs à caractère personnel (<a href="https://www.cnil.fr/fr/principes-cles/rgpd-se-preparer-en-6-etapes" target="_blank" title="en savoir plus à propos du RGPD">RGPD</a>)</strong></li>
						</ul>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Securite personnalisee</h2>
						</header>
						<p className="preul">Le <strong>suivi de sécurité</strong> concerne ces domaines :</p>
						<ul className="snow">
                            <li><strong>sites Internet</strong> (CMS et Extensions, Framework ou développements spécifiques)</li>
							<li><strong>services et applications</strong> diverses</li>
                            <li><strong>equipements réseaux</strong> Cisco, HP ...</li>
                            <li><strong>serveurs et postes de travail</strong> Linux, Unix, Windows et Apple</li>
                        </ul>
						<p className="bordertop">Vous trouverez le détail de mes compétences dans <strong><Link to="/cv/">mon CV</Link></strong>.</p>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Un suivi adapte</h2>
						</header>
						<p>Assurer un <strong>suivi des mises à jour de sécurité chaque mois</strong> permet d'effectuer une bonne veille avec un minimum de temps passé. Au final, c'est le <strong>meilleur rapport sécurité / coût prestation</strong>.</p>
						<p>En choississant ce suivi, vous pourrez <strong>contrer une grande partie des attaques</strong> tout en bénéficiant <strong>d'une prestation économique</strong>.</p>
						<p className="bordertop">N’hésitez pas à <strong><Link to="#contact">me contacter</Link></strong> pour un devis gratuit.</p>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Mes garanties</h2>
						</header>
						<p className="preul">Fort de mon expérience dans le domaine depuis plus de <strong>10 ans</strong> (<Link to='/CV/'>CV</Link>), je peux <strong>vous accompagner et garantir</strong> :</p>
						<ul className="snow">
							<li><strong>une veille constante</strong> sur les nouvelles <strong>vulnérabilités et attaques</strong> découvertes</li>
							<li>la <strong>configuration</strong> et le <strong>suivi mensuel</strong> des <strong>réseaux, PC, serveurs, applications et sites Internet</strong> pour assurer <strong>un niveau de sécurité maximal</strong></li>
							<li>une <strong>sensibilisation globale sur les bonnes pratiques</strong> à adopter dans le secteur de l'informatique</li>
						</ul>
						<p className="bordertop">N’hésitez pas à <strong><Link to="#contact">me contacter</Link></strong> pour un devis gratuit.</p>
					</div>
				</article>
			</section>
		</div>
	</div>
)

export default Generic



// WEBPACK FOOTER //
// ./src/pages/configuration-et-suivi-securite-informatique.js